import * as Immutable from "immutable";
import { TeamSyncBackends } from "@graylog/enterprise-api";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import GroupSyncBackend from "../logic/directoryServices/GroupSyncBackend";
import Group from "../logic/directoryServices/Group";
const apiPrefix = "/plugins/org.graylog.plugins.security/team-sync";
const ApiRoutes = {
  GroupsApiController: {
    loadGroups: () => ({ url: `${apiPrefix}/test/backend` }),
    update: (backendId) => ({ url: `${apiPrefix}/services/${backendId}/backend` }),
    create: (backendId) => ({ url: `${apiPrefix}/services/${backendId}/backend` }),
    delete: (backendId) => ({ url: `${apiPrefix}/services/${backendId}/backend` })
  }
};
export const loadMatchingGroups = (payload) => fetch("POST", qualifyUrl(ApiRoutes.GroupsApiController.loadGroups().url), payload).then(
  (response) => {
    if (response) {
      return {
        success: response.success,
        message: response.message,
        errors: Immutable.List(response.errors),
        list: response.result.groups ? Immutable.List(response.result.groups.map((g) => Group.fromJSON(g))) : Immutable.List()
      };
    }
    return null;
  }
);
export const createGroupSync = (backendId, payload) => fetch("POST", qualifyUrl(ApiRoutes.GroupsApiController.create(backendId).url), payload).then(
  (response) => ({
    backend: GroupSyncBackend.fromJSON(response.backend)
  })
);
export const loadGroupSync = (backendId) => TeamSyncBackends.get(backendId).then((response) => ({
  backend: GroupSyncBackend.fromJSON(response.backend)
}));
export const updateGroupSync = (backendId, payload) => fetch("PUT", qualifyUrl(ApiRoutes.GroupsApiController.update(backendId).url), payload).then(
  (response) => ({
    backend: GroupSyncBackend.fromJSON(response.backend)
  })
);
export const deleteGroupSync = (backendId) => fetch("DELETE", qualifyUrl(ApiRoutes.GroupsApiController.delete(backendId).url));
